import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  title: { paddingBottom: theme.spacing(3) }
}));
